import { req } from '../../@api/request';

export default class KakaoService {
  static chat = async (region_type: string) => {
    const result = await req.post(`/kakao/webhook/chat`, { region_type });
    return result.data;
  };
}
